// 移除藥物 component

<template lang="pug">
div
  div.upper-subpanel.row
    progressBar
    div.upper-subpanel--without-progressbar
      div.row(v-if="stage === 'selectDrug'" style="width: 100%; height: 100%; margin: 0")
        div.col-6
          selectBox
        div.col-6
          drugList
      MultiFlow(
        v-if="stage === 'setFlowData'" 
        :multiProgress="multiProgress"
        :confirmProgress="confirmProgress"
        v-on:setAllConfirmData="getAllConfirmData")
  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel")
    action-button(title="取消全選" slot="button-8" @click.native="unCheckAll" v-if="stage !== 'setFlowData'")
    action-button(title="選擇全部" slot="button-7" @click.native="checkAll" v-if="stage !== 'setFlowData'")
    action-button(title="開始移除" slot="button-9" @click.native="startFlow" v-if="stage !== 'setFlowData'")
            
</template>


<script>
import axios from 'axios';
import selectBox from './flowComp/PositionSelection';
import drugList from './flowComp/DrugInDeviceList';
import progressBar from './flowComp/ProgressBar';
import MultiFlow from './RemoveDrugFlow/MultiFlow';
import BottomButtons from './common/BottomButtons';
import AppBase from './ComponentBase/AppBase';

export default {
  name: 'CheckAmount',
  extends: AppBase,
  components: {
    selectBox,
    drugList,
    progressBar,
    MultiFlow,
    BottomButtons,
  },
  data() {
    return {
      stage: '',
    };
  },
  created() {
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    setupProgress() {
      const p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '移除藥物' });
      return p;
    },
    setupMultiProgress() {
      return [
        'confirm',
        'finish',
      ];
    },
    setupConfirmProgress() {
      const p = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push('confirmAmount');
      }
      p.push('wait');
      p.push('action');
      p.push('finish');
      p.push('setMinStock');
      return p;
    },
    checkAll() {
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    unCheckAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_UNLOAD' });
    },
    startFlow() {
      if (Object.keys(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.stage = 'setFlowData';
      }
    },
    async getAllConfirmData() {
      this.$store.dispatch('resetAll');
      await this.$store.dispatch('getSystemInfo');
      await this.$store.dispatch('getDrugInDevices');
      this.stage = 'selectDrug';
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    },
  },
};
</script>


// WEBPACK FOOTER //
// RemoveDrug.vue?35efea51